
export default {
  methods: {
    getLocaleNameById (list, id) {
      for (let index = 0; index < list.length; index++) {
        const item = list[index]
        if (item.id === id) {
          const name = 'name_' + this.$i18n.locale
          return item[name]
        }
      }
    },
    getTranslation (text) {
      if (text.includes('message.')) {
        return this.$t(text)
      }
      return text
    },
    handleSelectAll (values) {
      // console.log(values)
      if (values.length > 1 && values.includes(0)) {
        const index = values.indexOf(0)
        if (index === values.length - 1) {
          // when select all is added, remove others.
          values.splice(0, index)
        } else {
          values.splice(index, 1)
        }
      }
    },
    toListItem (list) {
      const items = [
        {
          value: 0,
          text: this.$t('message.component.select_all')
        }
      ]
      list.forEach(item => {
        items.push({
          text: item[this.$i18n.locale],
          value: item.id
        })
      })
      return items
    }
  },
  computed: {
    isMobile () {
      return this.$vuetify.breakpoint.mobile
    }
  }
}
